import app from 'flarum/common/app';

/** Status em que o alert é responsabilidade DAQUI (o call site não tem o que dizer). */
const GLOBAL_ALERT = {
  0: 'network_offline',
  401: 'session_expired',
  403: 'permission_denied',
  429: 'rate_limited'
};
function alertCodeFor(status) {
  if (status >= 500) return 'network_5xx';
  return GLOBAL_ALERT[status] ?? null;
}

/**
 * Wrapper central de chamadas API. Ele é o ÚNICO dono da mensagem de erro das
 * requisições do marketplace:
 *
 *   1. Desliga o handler padrão do core (`errorHandler`). O core monta o alert
 *      de 422 a partir de `response.errors[]` (JSON:API); os controllers desta
 *      extensão respondem `{"error": "codigo:detalhe"}`, então o core não achava
 *      texto nenhum e mostrava um alert VERMELHO VAZIO em cima do nosso.
 *   2. Mostra alert só onde o call site não teria o que dizer: offline, 5xx,
 *      sessão expirada, sem permissão, rate limit. Erro de regra de negócio
 *      (400/404/409/422) fica em silêncio: a tela mostra a mensagem específica.
 *   3. Re-lança a Promise rejeitada, então todo `try/catch` existente continua
 *      funcionando igual.
 */
export function api(method, path, body) {
  // app.forum só fica populado depois de app.boot() — initializers podem
  // tentar chamar api() antes disso (ex: cart boot best-effort). Resolve
  // apiUrl com fallback relativo pra evitar `Cannot read 'attribute' of undefined`.
  const apiUrl = app && app.forum && typeof app.forum.attribute === 'function' ? app.forum.attribute('apiUrl') : '/api';
  return app.request({
    method,
    url: apiUrl + path,
    body,
    // Devolver qualquer coisa != false faz o core pular o handler padrão
    // dele (que é quem exibia o alert vazio). O tratamento fica no catch.
    errorHandler: () => true
  }).catch(e => {
    const status = e?.status ?? 0;
    console.error('[marketplace api]', method, path, {
      status,
      error: e?.response?.error,
      raw: e
    });
    const code = alertCodeFor(status);
    if (code && app?.alerts?.show && app?.translator) {
      const msg = app.translator.trans('ramon-marketplace.lib.errors.' + code);
      app.alerts.show({
        type: 'error',
        dismissible: true
      }, msg || 'Erro de rede. Tente novamente.');
    }
    throw e;
  });
}
flarum.reg.add('ramon-marketplace', 'common/utils/api', { api: api, });